import DashboardTemplate from "../../../templates/admin/dashboard";

const DashboardScreen = () => {
  return <DashboardTemplate />;
};

export default DashboardScreen;
